export default __webpack_public_path__ + "static/Vol 3 - TA 7  G&G (with appendices)-81dd198bf1b77a63abf38f27f895dbbe.pdf";